export default __webpack_public_path__ + "static/media/logo_with_wordmark.dc48d06d.svg";